<template>
  <div>
    <qb-table>
      <template v-slot:thead>
        <qb-tr style="width: 100%">
          <qb-th class="f-14">
            {{ $t('client') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('facility',1) | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('headcount') | capitalize }} <br />
            {{ $t('active') | capitalize }} / {{ $t('required') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('direct') | capitalize }} {{ $t('headcount') | capitalize }} <br />
            {{ $t('active') | capitalize }} / {{ $t('required') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('indirect') | capitalize }} {{ $t('headcount') | capitalize }} <br />
            {{ $t('active') | capitalize }} / {{ $t('required') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('ups') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('downs') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 10px"></qb-th>
        </qb-tr>
      </template>
      <template v-slot:tbody>
        <!-- <qb-tr v-for="(el, idx) in data" :key="idx"> -->
        <qb-tr v-for="(el, idx) in data" :key="idx">
          <qb-td>{{ el.ClientName | capitalize }}</qb-td>
          <qb-td>{{ el.Facility | capitalize }}</qb-td>
          <!-- headcoun general -->
          <qb-td>{{ el.Columna_1 }} / {{ el.Columna_4+ (el.Columna_6+(el.Columna_1-el.Columna_3)) }}</qb-td>
          <!-- directo -->
          <qb-td>{{ el.Columna_3 }} / {{ el.Columna_4 }}</qb-td>
          <!-- indirect -->
          <qb-td>{{ el.Columna_1-el.Columna_3 }} / {{ el.Columna_6+(el.Columna_1-el.Columna_3) }}</qb-td>
          <qb-td>{{ el.up }}</qb-td>
          <qb-td>{{ el.down }}</qb-td>
        </qb-tr>
        <qb-tr>
          <qb-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </qb-td>
        </qb-tr>
      </template>
    </qb-table>
  </div>
</template>

<script>
import QbTable from '@/views/qb-components/table/QbTable.vue'
import QbTr from '@/views/qb-components/table/QbTr.vue'
import QbTh from '@/views/qb-components/table/QbTh.vue'
import QbTd from '@/views/qb-components/table/QbTd.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  name: 'headcount-table',
  components: {
    ActionIcon,
    QbTable,
    QbTr,
    QbTh,
    QbTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
  },
}
</script>

<style>
.chip-status {
  max-width: 9rem;
  min-width: 2rem;
  color: white;
  text-align: center;
  border-radius: 0.3em;
}
</style>
